import {
  Box,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import React, { forwardRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "axios/axiosInstance";
import greenTick from "assets/images/green-check.png";
import { formatDate } from "date-fns";
import { useSearchParams } from "react-router-dom";
import baseUrl from "helpers/baseUrl";

const Transition = forwardRef((props, ref) => (
  <Slide direction="right" ref={ref} {...props} timeout={1200} />
));

export default function TicketVerify() {
  const [searchParams] = useSearchParams();
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [isVerified, setVerified] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [verifiedTicketDetails, setVerifiedTicketDetails] = useState();
  const [isDialogOpen, setDialogOpen] = useState(true);
  const [ticketDetails, setTicketDetails] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("Please check the ticket details or contact support.");
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const eventId = searchParams.get("eventId");
  const ticketId = searchParams.get("ticketId");

  useEffect(() => {
    if (eventId && ticketId) {
      verifyCalls();
    }
  }, [eventId, ticketId]);

  const verifyCalls = async () => {
    setVerificationLoading(true);
    try {
      const response = await axiosInstance.get(
        `${baseUrl.baseUrl}/events/verifyTickets/${eventId}/${ticketId}`
      );
      if (!response?.data?.error) {
        setVerified(true);
        setTicketDetails(response?.data?.event);
        setLoading(false);
      } else {
        setError(response?.data?.error);

        setIsInvalid(true);
        setLoading(false);
      }
    } catch (error) {
      console.error("Verification failed", error);
    }
  };

  const onClose = () => {
    setDialogOpen(false);
    navigate(`/myTickets`);
  };

  if (loading) {
    return <CircularProgress />;
  }
  console.log("###new Date(ticketDetails?.eventDateTime)", ticketDetails);

  return (
    <>
      {isVerified && (
        <Dialog
          fullWidth
          fullScreen={fullScreen}
          maxWidth="sm"
          open={isDialogOpen}
          onClose={onClose}
          TransitionComponent={Transition}
          sx={{
            "& .MuiPaper-root": {
              // backgroundColor: "black",
              backgroundColor: "#00303A !important", // Change this to your desired color
            },
          }}
        >
          <DialogTitle display="flex" justifyContent="center" alignItems="center" sx={{ p: 2 }}>
            <Box
              component="img"
              src={greenTick}
              alt="Event Verification"
              sx={{
                width: { xs: "15%", sm: "7%" },
                objectFit: "contain",
              }}
            />
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem" },
                textAlign: "center",
              }}
            >
              Ticket Verified!
            </Typography>
          </DialogTitle>

          {/* Set maxHeight and enable scrolling for content */}
          <DialogContent
            dividers
            sx={{
              p: 0,
              // background: "#8F71DB1F",
              maxHeight: { xs: "50vh", sm: "80vh" }, // Set max height
              overflowY: "auto",
              borderTop: "none",
              borderBottom: "none", // Enable scrolling if content overflows
            }}
          >
            <Box sx={{ px: { xs: 1, sm: 10 }, py: 4 }}>
              <Box
                display="flex"
                justifyContent="center"
                gap={2}
                sx={{
                  overflowX: "auto",
                  width: { xs: "100%", sm: "auto" },
                  flexWrap: "nowrap",
                }}
              >
                {/* Add ticket images or details here */}
              </Box>
              {ticketDetails && (
                <Box display="flex" justifyContent="center" gap={3} mt={2}>
                  <Typography variant="body2">
                    {ticketDetails?.soldTo?.length}{" "}
                    <span style={{ fontWeight: 600 }}>
                      {ticketDetails?.soldTo?.length === 1 ? "Ticket " : "Tickets "}Verified
                    </span>
                  </Typography>
                  <Typography variant="body2">
                    Valid till:{" "}
                    <span style={{ fontWeight: 600 }}>
                      {ticketDetails?.eventDateTime
                        ? new Date(ticketDetails?.eventDateTime).toLocaleDateString()
                        : "Invalid date"}{" "}
                    </span>
                  </Typography>
                </Box>
              )}
            </Box>
          </DialogContent>

          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: -2, sm: 0 }, // Move up on mobile
            }}
          >
            <Button
              style={{
                width: { xs: "80%", sm: "25%" },
                mb: { xs: 2, sm: 0 },
                backgroundColor: "#F57C00",
                color: "#fff",
              }}
              variant="contained"
              onClick={onClose}
              data-blast="bgColor"
              // color="primary"
            >
              Done
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {isInvalid && (
        <Dialog
          fullWidth
          fullScreen={fullScreen}
          maxWidth="sm"
          open={isDialogOpen}
          onClose={onClose}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              backgroundColor: "#00303A !important", // Change this to your desired color
            },
          }}
        >
          <DialogContent
            dividers
            sx={{
              p: 0,
              // background: "#8F71DB1F",
              maxHeight: { xs: "50vh", sm: "80vh" }, // Set max height
              overflowY: "auto",
              borderTop: "none",
              borderBottom: "none", // Enable scrolling if content overflows
            }}
          >
            <Box sx={{ px: { xs: 1, sm: 10 }, py: 4 }}>
              <Box
                display="flex"
                justifyContent="center"
                gap={2}
                sx={{
                  overflowX: "auto",
                  width: { xs: "100%", sm: "auto" },
                  flexWrap: "nowrap",
                }}
              >
                <Box
                  component="div"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography variant="h5" color="red">
                    Invalid Ticket!
                  </Typography>
                  <ErrorIcon sx={{ color: "red", fontSize: { xs: 60, sm: 100 } }} />
                  <Typography variant="body1" color="secondary">
                    {error}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: -2, sm: 0 }, // Move up on mobile
            }}
          >
            <Button
              style={{
                width: { xs: "80%", sm: "25%" },
                mb: { xs: 2, sm: 0 },
                backgroundColor: "#F57C00",
                color: "#fff",
              }}
              data-blast="bgColor"
              variant="contained"
              onClick={onClose}

              // variant="contained"
              // // /  type="submit"
              // disabled
              // data-blast="bgColor"
              // style={{
              //   backgroundColor: `#00EDC5`,
              //   fontWeight: 700,
              //   borderRadius: "24px",
              //   color: "#fff",
              // }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
